import { FC } from 'react';
import { FAQ, META_IMAGE_LINK_FILGRAM } from 'constants/general';
import { ROUTES } from 'constants/routes';
import useTranslation from 'next-translate/useTranslation';
import TransText from 'next-translate/TransText';
import PageWrapper from 'components/Common/PageWrapper/PageWrapper';
import Brackets from 'components/Common/Brackets/Brackets';
import CustomLink from 'components/Common/CustomLink/CustomLink';

import styles from './Faq.module.scss';

const Faq: FC = () => {
  const { t } = useTranslation('faq');

  return (
    <>
      <PageWrapper
        seoData={{
          title: t('frequentlyAskedQuestions'),
          description: t('thisIsTheListOfInsights'),
          link: `${process.env.BASE_URL}${ROUTES.FAQ}`,
          metaImageLink: META_IMAGE_LINK_FILGRAM,
        }}
        additionalClass={styles['faq-wrapper']}
      >
        <h1 className={styles.title}>{t('frequentlyAskedQuestions')}</h1>
        <h2 className={styles.subtitle}>{t('thisIsTheListOfInsights')}</h2>
        {FAQ.map((item, index) => (
          <div key={item.question} className={styles['faq-item-wrapper']}>
            <div className={styles['faq-item-content']}>
              <div className={styles['faq-item-title-wrapper']}>
                <Brackets newStyles={styles}>{index + 1}</Brackets>
                <h3 className={styles['faq-item-title']}>{t(item.question)}</h3>
              </div>
              <div className={styles['faq-item-text']}>
                <TransText
                  text={t(item.answer, {}, { returnObjects: true })}
                  components={{
                    link1: (
                      <CustomLink
                        linkProps={{
                          href: 'https://docs.filecoin.io/about-filecoin/faq/',
                        }}
                        targetBlank
                      />
                    ),
                    link2: (
                      <CustomLink
                        linkProps={{
                          href: 'https://filplus.d.interplanetary.one/about',
                        }}
                        targetBlank
                      />
                    ),
                    link3: (
                      <CustomLink
                        linkProps={{
                          href: `${ROUTES.HOME}#calculator`,
                        }}
                      />
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </PageWrapper>
    </>
  );
};

export default Faq;
